import * as React from "react";
import { Helmet } from "react-helmet";
import { fetchData, postQuery, uploadFile } from '../utils'
import * as AuthStore from "../store/Auth";
import * as moment from 'moment';
import { ApplicationState } from '../store';
import * as Highcharts from 'highcharts';
import { connect } from "react-redux";
import { Table, Button, Select, DatePicker, message, Form, Row, Col, Modal, Input } from 'antd';
import { SearchOutlined, EditFilled } from '@ant-design/icons';
import { busyGif } from '../img';
const { Option } = Select;
const { Item } = Form;

type AuthProps =
    AuthStore.AuthState // ... state we've requested from the Redux store
    & typeof AuthStore.actionCreators // ... plus action creators we've requested

class CounsellingRequest extends React.Component<AuthProps>
{
    public state =
    {
        buttonText: 'Add',
        data: [],
        pagination:
        {
            current: 1,
            total: 0,
            pageSize: 10,
            sorter: {
                field: "name",
                order: "asc"
            }
        },
        loading: false,
            confirmLoading: false,
            fLoading: false,
        title: 'New Request',
            request: {
                id: 0, patientId: 0, serviceProviderId: 0, reasonId: 0, dateInitiated: '', dateServiced: '', status: 1, rating: 0, requestMessage: '', pepfarId: '',
                provider: '', reasonName: '', dateInitiatedStr: '', dateServicedStr: '', statusStr: '', ratingStr: '', stateName: '', facilityName: '', stateId: 0 },
        searchText: "",
            visible: false,
            states: [],
        hideUpload: false,
            showDetails: false,
            statesLoaded: true,
            providers: [],
            stateProviders: [],
            defaultChecked: true,
            state: { stateId: 0, stateName: '', stateCode: '', sites: [] },
    };

    async componentDidMount()
    {
        const { pagination } = this.state;

        let sts = localStorage.getItem("states");
        let states = [];
        if (sts) states = JSON.parse(sts);
        let statesLoaded = true;
        this.setState({ states, statesLoaded });

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current,
            sortField: pagination.sorter.field,
            sortOrder: pagination.sorter.order
        });

        var query = `/api/Jolly95/getProviders?stateCode`;
        let res = await fetchData(query);
        this.setState({ providers: res });
    }
    
    handleTableChange(pagination: any, filters: any, sorter: any)
    {
        const pager = this.state.pagination;
        pager.current = pagination.current;

        this.setState({
            pagination: pager
        });
        this.getItems({
            results: pager.pageSize,
            searchText: this.state.searchText,
            page: pager.current,
            sortField: pager.sorter.field,
            sortOrder: pager.sorter.order
        });
    }  
 
    async getItems(params: any)
    {
        this.setState({ loading: true });
        var searchText = params.searchText;
        var results = params.results;
        var page = params.page;
        let el = this;

        var query = `/api/Jolly95/getCounsellingRequests?itemsPerPage=${results}&pageNumber=${page}&searchText=${searchText}`;

        let res = await fetchData(query);

        const { pagination } = el.state;
            pagination.total = res.totalItems;           
            el.setState({
                data: res.counsellingRequests,
                pagination,
                loading: false 
            });                      

        if (searchText && searchText.trim().length > 0)
        {
            const reg = new RegExp(searchText, 'gi');
            this.setState({
                filtered: !!searchText,
                data: this.state.data.map((record: any) =>
                {
                    const match = record.name.toString().match(reg);

                    if (!match)
                    {
                        return null;
                    }
                    return {
                        ...record,
                        name: (<span> {record.name.split(reg).map((text: any, i: any) => (i > 0 ? [<span key={record.id} className="highlight">{match[0]}</span>, text] : text
                        ))}
                        </span>
                        )
                    };
                }).filter(record => !!record)
            });
        }
    }

    handleChange(value: any)
    {
        const { pagination } = this.state;
        pagination.pageSize = parseInt(value);

        this.setState({
            pagination: pagination
        });

        this.getItems({
            results: pagination.pageSize,
            searchText: this.state.searchText,
            page: pagination.current
        });
    }
    
    onInputChange(e: any)
    {
        let searchTerm = e.target.value.trim();
        this.setState({searchText: searchTerm});       
    }

    onSearch()
    {
        let el = this;
        const { pagination } = el.state;
        if (!el.state.searchText || el.state.searchText.length < 1)
        {
            message.error('Please provide a search entry');
            return;
        }
        this.getItems({
            results: pagination.pageSize,
            searchText: el.state.searchText,
            page: pagination.current
        });
    }

    edit(data: any, row: any)
    {
        let { stateProviders, providers } = this.state;
        stateProviders = providers.filter(p => p.stateId === data.stateId);      
        console.log(providers);
        console.log(stateProviders);
        this.setState({ visible: true, title: 'Update Request', buttonText: 'Update', request: data, stateProviders });
    }

    async process()
    {
        let el = this;       
        if (el.state.request.status < 1)
        {
            message.error('Select a Status');
            return;
        }

        let url = '/api/Jolly95/updateCounsellingRequest';
        
        const { pagination } = el.state;
        let params =
        {
            results: pagination.pageSize,
            searchText: el.state.searchText,
            page: pagination.current
        };

        el.setState({ confirmLoading: true });
        let res = await postQuery(url, JSON.stringify(el.state.request));
        el.setState({ confirmLoading: false });
        if (res.code > 0)
        {
            el.getItems(params);
            el.setState({ visible: false });
            message.success(res.message);
        }
        else
        {
            message.error(res.message);
        }
    }
        
    exit() {
        this.setState({
            visible: false, hideUpload: false
        });
    }
    
    textChange(feture: any, e: any)
    {
        let Request = this.state.request;        
        Request[feture] = e.target.value;
        this.setState({ Request });
    }

    selectProvider(value: any)
    {
        if (!value)
        {
            return;
        }

        const { request } = this.state;

        if (value)
        {
            let val = value.key;
            request.serviceProviderId = val;
            this.setState({ request });
        }
    }

    selectStatus(value: any)
    {
        if (!value) {
            return;
        }

        const { request } = this.state;

        if (value) {
            let val = value.key;
            request.status = val;
            this.setState({ request });
        }
    }

    dateChange(date: any, dateString: any)
    {
        let to = '';
        if (dateString) {
            to = dateString;
        }
        const { request } = this.state;
        request.dateServiced = to;
        request.dateServicedStr = to;
        this.setState({ request });
    }

    render()
    {
        const { title, states, state, stateProviders, confirmLoading, visible, showDetails, request, searchText, buttonText, defaultChecked } = this.state;
        let el = this;
        const user = this.props.appUser;
               
        const columns =
            [
                {
                    title: 'Initiated by',
                    dataIndex: 'pepfarId',
                    key: 'pepfarId',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Reason',
                    dataIndex: 'reasonName',
                    key: 'reasonName',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Date Initiated',
                    dataIndex: 'dateInitiatedStr',
                    key: 'dateInitiatedStr',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Date Serviced',
                    dataIndex: 'dateServicedStr',
                    key: 'dateServicedStr',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Request Status',
                    dataIndex: 'statusStr',
                    key: 'statusStr',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Client Rating',
                    dataIndex: 'ratingStr',
                    key: 'ratingStr',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Facility',
                    dataIndex: 'facilityName',
                    key: 'facilityName',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },
                {
                    title: 'Provider',
                    dataIndex: 'provider',
                    key: 'provider',
                    render: (value: any, row: any, index: any) => <span className="tb-span" key={row.id}>{value}</span>
                },                ,
                {
                    title: 'Update',
                    dataIndex: '', key: 'x',
                    render: (value, row, index) => <EditFilled onClick={() => this.edit(value, row)} key={value.id} style={{ cursor: 'pointer' }} />
                }
            ]; 
        
        return (
            <div style={{ marginTop: '15px', padding: '20px' }}>
                <Helmet>
                    <title>CDR - Requests</title>
                </Helmet>                
                <div className="custom-filter-dropdown" style={{ display: showDetails ? 'none' : 'block' }}>
                    <Row style={{ marginTop: '2px' }}>
                        <Col span={24}>
                            <h4 style={{ fontWeight: 'bold', fontSize: '18px' }}>Requests</h4>
                        </Col>
                    </Row>
                    <Row gutter={2}>
                        <Col xs={24} sm={24} md={3} lg={3}>
                            <Select className="top-10-margin" defaultValue="10" id="pageSize" onChange={(v) => this.handleChange(v)}>
                                <Option value="10">10</Option>
                                <Option value="25">25</Option>
                                <Option value="50">50</Option>
                                <Option value="100">100</Option>
                            </Select>
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                            <Input className="ant-input-lg-2 top-10-margin" style={{ width: '100%' }} placeholder="Search by name or State code..." value={searchText} onChange={(s) => el.onInputChange(s)} onPressEnter={() => el.onSearch()} />                                                       
                        </Col>
                        <Col xs={24} sm={24} md={4} lg={4}>
                        </Col>
                    </Row>
                    <br />
                    <Row gutter={2}>
                        <Col span={24} style={{overflow: "scroll"}}>
                            <Table columns={columns} rowKey={record => record.id} dataSource={this.state.data} pagination={this.state.pagination} loading={this.state.loading} onChange={(a: any, b: any, c: any) => this.handleTableChange(a, b, c)} bordered />
                        </Col>
                    </Row>
                </div>
                <div className="md-wrapper">
                    <Modal className="modal-width-500"
                        visible={visible}
                        title='Conselling Request'
                        maskClosable={false}
                        onCancel={() => this.exit()}
                        footer={[
                            <Button loading={confirmLoading} disabled={confirmLoading} style={{ width: '27%' }}  className="login-button" key="submit" type="primary" size="large" onClick={() => this.process()}>
                                <span id="buttonText">Update</span>
                            </Button>
                        ]}>
                        <Form>
                            <div className='ant-row'>
                                <div className='ant-col-24 padding-md border-c'>
                                    Client: <h6>{request.pepfarId}</h6>
                                </div>
                                <div className='ant-col-24 padding-md border-c'>
                                    Facility: <h6>{request.facilityName}</h6>
                                </div>                                
                                <div className='ant-col-24 padding-md border-c'>                                    
                                    <div className='ant-row'>
                                        <div className='ant-col-12 padding-md'>
                                            Reason: <h6>{request.reasonName}</h6>
                                        </div>
                                        <div className='ant-col-12 padding-md'>
                                            Date Initiated: <h6>{request.dateInitiatedStr}</h6>
                                        </div>
                                    </div> 
                                </div>
                                <div className='ant-col-24 padding-md border-c'>
                                    Date Serviced: <h6>{request.dateServicedStr}</h6>
                                </div>
                                <div className='ant-col-24 padding-md border-c' style={{ maxHeight: '100px', overflow: 'scroll' }}>
                                    Message:
                                   <p>{request.requestMessage}</p>
                                </div>
                                <div className='ant-col-24 padding-md'>                                    
                                    <div className='ant-row'>
                                        <div className={request.status && request.status === 3 ? 'ant-col-12' : 'ant-col-24'}>
                                             <Select className="circl-radius"
                                                labelInValue
                                                showSearch
                                                optionFilterProp="children"
                                                disabled={confirmLoading}
                                                //@ts-ignore
                                                value={{ key: request.status }}
                                                style={{ width: '100%' }}
                                                placeholder="Select Request Status"
                                                onChange={(value) => this.selectStatus(value)}
                                            >
                                                <Option key='' value=''>-- Update Request Status --</Option>
                                                <Option key={1} value={1}>Pending</Option>
                                                <Option key={2} value={2}>Processing</Option>
                                                <Option key={3} value={3}>Serviced</Option>
                                            </Select>
                                        </div>
                                        {request.status && request.status === 3 &&  <div className='ant-col-12'>
                                            <DatePicker placeholder='Date Request was serviced' className="circl-radius" style={{ marginLeft: '7px' }}
                                                //@ts-ignore
                                                value={request.dateServiced && request.dateServiced.length > 0 ? moment(request.dateServiced, "YYYY-MM-DD") : null} allowClear={true}
                                                onChange={(a: any, b: any) => this.dateChange(a, b)} />
                                        </div> }                                     
                                    </div>
                                </div>                                
                                <div className='ant-col-24 padding-md border-c'>
                                    <Item>
                                        <Select className="circl-radius"
                                            showSearch
                                            labelInValue
                                            optionFilterProp="children"
                                            disabled={confirmLoading}
                                            style={{ width: '99%', float: 'right' }}                                            
                                            //@ts-ignore
                                            value={{key: request.serviceProviderId}}
                                            placeholder="Assign to Counsellor/Service Provider"
                                            onChange={(value) => this.selectProvider(value)}
                                        >
                                            <Option key='' value=''>-- Select Counsellor/Service Provider --</Option>
                                            {stateProviders && stateProviders.map((s: any) => <Option key={s.id} value={s.id}>{s.fullName}</Option>)}
                                        </Select>
                                    </Item>
                                </div>
                            </div>
                        </Form>
                    </Modal>
                </div>
            </div>
        )
    }
}

export default connect(
    (state: ApplicationState) => state.auth, // Selects which state properties are merged into the component's props
    AuthStore.actionCreators // Selects which action creators are merged into the component's props
)(CounsellingRequest as any);
